var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnsync(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 98,
    height: 97,
    viewBox: "0 0 98 97",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 49,
    cy: 48.5,
    r: 48.5,
    fill: "#DB5F5F",
    fillOpacity: 0.35
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10489_91080)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1719 48.3986C19.1719 43.66 19.1719 41.2907 19.8272 39.3826C21.0377 35.8577 23.8069 33.0885 27.3318 31.878C29.2399 31.2227 31.6092 31.2227 36.3478 31.2227H38.8108C42.6096 31.2227 44.509 31.2227 46.0857 31.5528C52.1306 32.8187 56.8536 37.5417 58.1195 43.5866C58.4497 45.1633 58.4497 47.0627 58.4497 50.8615C58.4497 54.6604 58.4497 56.5598 58.1195 58.1365C56.8536 64.1814 52.1306 68.9044 46.0857 70.1703C44.509 70.5004 42.6096 70.5004 38.8108 70.5004C35.0119 70.5004 33.1125 70.5004 31.5359 70.1703C25.4909 68.9044 20.7679 64.1814 19.502 58.1365C19.1719 56.5598 19.1719 54.6604 19.1719 50.8615V48.3986Z",
    fill: "#DB5F5F"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 46.0697,
    cy: 46.3383,
    r: 5.5541,
    fill: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M66.3851 32.5987C64.8096 32.5987 63.5352 31.3713 63.5352 29.8296C63.5352 28.288 64.8096 27.0508 66.3851 27.0508C67.9606 27.0508 69.2049 28.288 69.2049 29.8296C69.2049 31.3713 67.9606 32.5987 66.3851 32.5987Z",
    fill: "#DB5F5F"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M75.4386 32.1465C75.2479 31.8519 74.977 31.5573 74.6258 31.3708C74.3448 31.2333 74.1641 31.0075 74.0036 30.7423C73.4918 29.8979 73.7929 28.7883 74.6458 28.2875C75.6493 27.7278 75.9704 26.4807 75.3884 25.5086L74.7161 24.35C74.1441 23.3778 72.8897 23.0342 71.8963 23.6037C71.0132 24.075 69.8792 23.7608 69.3675 22.9262C69.2069 22.6512 69.1166 22.3566 69.1367 22.0621C69.1668 21.6791 69.0463 21.3158 68.8657 21.0212C68.4944 20.4124 67.8221 20 67.0795 20H65.6646C64.932 20.0196 64.2597 20.4124 63.8884 21.0212C63.6977 21.3158 63.5873 21.6791 63.6074 22.0621C63.6275 22.3566 63.5372 22.6512 63.3766 22.9262C62.8648 23.7608 61.7309 24.075 60.8578 23.6037C59.8543 23.0342 58.61 23.3778 58.028 24.35L57.3557 25.5086C56.7837 26.4807 57.1048 27.7278 58.0982 28.2875C58.9512 28.7883 59.2523 29.8979 58.7505 30.7423C58.5799 31.0075 58.3993 31.2333 58.1183 31.3708C57.7771 31.5573 57.4761 31.8519 57.3155 32.1465C56.9442 32.7553 56.9643 33.5212 57.3356 34.1595L58.028 35.3378C58.3993 35.9662 59.0917 36.359 59.8142 36.359C60.1554 36.359 60.5568 36.2608 60.8779 36.0644C61.1288 35.8975 61.4298 35.8386 61.761 35.8386C62.7544 35.8386 63.5873 36.6536 63.6074 37.6257C63.6074 38.7549 64.5306 39.6386 65.6947 39.6386H67.0594C68.2134 39.6386 69.1367 38.7549 69.1367 37.6257C69.1668 36.6536 69.9997 35.8386 70.9931 35.8386C71.3142 35.8386 71.6153 35.8975 71.8762 36.0644C72.1973 36.2608 72.5887 36.359 72.9399 36.359C73.6524 36.359 74.3448 35.9662 74.7161 35.3378L75.4185 34.1595C75.7798 33.5016 75.8099 32.7553 75.4386 32.1465Z",
    fill: "#DB5F5F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10489_91080"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 60,
    height: 60,
    fill: "white",
    transform: "translate(18.5 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnsync);
export default __webpack_public_path__ + "static/media/unsync.1c985335fc3e49d7575eab7235a4365e.svg";
export { ForwardRef as ReactComponent };